export default {
  title: 'Datepicker',
  type: 'object',
  properties: {
    dateStart: {
      type: 'string',
      format: 'date',
      title: 'Data rozpoczęcia',
      fieldRequired: 'true'
    },
    dateEnd: {
      type: 'string',
      format: 'date',
      title: 'Data zakończenia',
      fieldRequired: 'true',
      minimum: 'this.dateStart'
    },
    reason: {
      type: 'string',
      fieldRequired: 'true',
      validationMessages: {
        fieldRequired: 'Podaj powód swojej nieobecnosci'
      }
    },
    allDay: {
      title: 'Całodzienny',
      type: 'boolean',
      default: 'true',
      calc: {
        when: '$methods.dateDiff($root.dateStart, $root.dateEnd).days !== 0',
        func: 'true'
      }
    },
    hourStart: {
      allOf: [
        { $ref: '#/definitions/hour' },
        {
          title: 'Godzina rozpoczęcia',
          validFunc: 'this.allDay ? true : (this.hourEnd < 6 ? true : $value <= this.hourEnd)',
          validationMessages: {
            validFunc: 'Godzina rozpoczęcia musi być wcześniejsza niż godzina zakończenia'
          }
        }
      ]
    },
    minuteStart: {
      allOf: [
        { $ref: '#/definitions/minute' },
        {
          title: 'Minuta rozpoczęcia',
          validFunc: 'this.allDay ? true : ((this.hourStart < 6 || this.hourEnd < 6 || this.hourStart !== this.hourEnd) ? true : $value < this.minuteEnd)',
          validationMessages: {
            validFunc: 'Godzina rozpoczęcia musi być wcześniejsza niż godzina zakończenia'
          }
        }
      ]
    },
    hourEnd: {
      allOf: [
        { $ref: '#/definitions/hour' },
        {
          title: 'Godzina zakończenia',
          validFunc: 'this.allDay ? true : (this.hourStart < 6 ? true : $value >= this.hourStart)',
          validationMessages: {
            validFunc: 'Godzina zakończenia musi być późniejsza niż godzina rozpoczęcia'
          }
        }
      ]
    },
    minuteEnd: {
      allOf: [
        { $ref: '#/definitions/minute' },
        {
          title: 'Minuta zakończenia',
          validFunc: 'this.allDay ? true : ((this.hourStart < 6 || this.hourEnd < 6 || this.hourStart !== this.hourEnd) ? true : $value > this.minuteStart)',
          validationMessages: {
            validFunc: 'Godzina zakończenia musi być późniejsza niż godzina rozpoczęcia'
          }
        }
      ]
    }
  },
  definitions: {
    hour: {
      type: 'number',
      fieldRequired: '!$root.allDay',
      minimum: '$root.allDay ? null : 6',
      maximum: '$root.allDay ? null : 20',
      calc: {
        when: '$root.allDay',
        func: 'null'
      }
    },
    minute: {
      type: 'number',
      fieldRequired: '!$root.allDay',
      minimum: '$root.allDay ? null : 0',
      maximum: '$root.allDay ? null : 59',
      calc: {
        when: '$root.allDay',
        func: 'null'
      }
    }
  }
};
